module.exports = __webpack_public_path__ + "static/media/bitlock_image.c805c61d.png";